<template>
    <section v-if="oem && productLine"
             class="bg-white">
        <div class="container">

            <div :class="{'justify-between' : !screenSize.xs, 'justify-center' : screenSize.xs}" class="row items-end q-mb-lg">

                <a :href="oem.websiteURL" target="_blank" :class="{'no-pointer-events':oem.code=='GN'}"><img :src="oem.logoPath" class="float-right img-oem-logo" :title="oem.name" /></a>
                <img v-if="oem.productCategoryID.toLowerCase() == 'plumbingcad'" :src="plumbingCAD.logo" :title="plumbingCAD.name" class="img-logo q-ml-lg q-mt-md" />
                <img v-if="oem.productCategoryID.toLowerCase() == 'loopcad' && oem.code!=='GN'" :src="loopCAD.logo" :title="loopCAD.name" class="img-logo q-ml-lg q-mt-md" />
            </div>

            <div :class="{'text-center' : screenSize.xs}">
                <div class="text-title">{{ oem.downloadTitle }}</div>
                <p v-html="oem.description" />
            </div>
            <div class="q-pt-sm">
                <div class="row q-col-gutter-sm" v-if="screenSize.gt.sm">
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="primary" :label="`${productLine.name} Details`"
                               :to="`/product/${productLine.name.toLowerCase()}`" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="positive" label="Pricing"
                               :to="{ name:'/store', params: { productLine: productLine.name.toLowerCase() }}" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="positive" label="Activate"
                               v-if="oem.name.toLowerCase() !== 'lengthwise'"
                               :to="`/activation/${productLine.name.toLowerCase()}`" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="primary" label="Revison History"
                               v-if="oem.name.toLowerCase() !== 'lengthwise'"
                               @click="goToRevisionHistory" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn v-if="oem.id.toLowerCase() == 'upus' || oem.id.toLowerCase() == 'upca'"
                               color="primary"
                               @click="redirect">
                            <img class="on-left" style="max-height: 24px" :src="oem.id.toLowerCase() == 'upus' ? require('@/assets/img/flags/canada.png') : require('@/assets/img/flags/usa.png')" />
                            {{ (oem.id.toLowerCase() == 'upus') ? 'Click here for Canadian Edition' : 'Click here for US Edition' }}
                        </q-btn>
                    </div>
                </div>

                <div class="row q-col-gutter-sm" v-else>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="primary" :label="`${productLine.name} Details`"
                               :to="`/product/${productLine.name.toLowerCase()}`" class="full-width q-mb-xs" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="positive" label="Pricing"
                               :to="{ name:'/store', params: { productLine: productLine.name.toLowerCase() }}" class="full-width q-mb-xs" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="positive" label="Activate"
                               v-if="oem.name.toLowerCase() !== 'lengthwise'"
                               :to="`/activation/${productLine.name.toLowerCase()}`" class="full-width q-mb-xs" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn color="primary" label="Revison History"
                               v-if="oem.name.toLowerCase() !== 'lengthwise'"
                               @click="goToRevisionHistory" class="full-width q-mb-xs" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn v-if="oem.id.toLowerCase() == 'upus' || oem.id.toLowerCase() == 'upca'"
                               class="full-width"
                               color="primary"
                               @click="redirect">
                            <img class="on-left" style="max-height: 24px" :src="oem.id.toLowerCase() == 'upus' ? require('@/assets/img/flags/canada.png') : require('@/assets/img/flags/usa.png')" />
                            {{ (oem.id.toLowerCase() == 'upus') ? 'Click here for Canadian Edition' : 'Click here for US Edition' }}
                        </q-btn>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'oem-download',
        props: {
            oem: Object,
            productLine: Object,
        },
        data() {
            return {
                oemId: '',
                plumbingCAD: productLines.PlumbingCAD,
                loopCAD: productLines.LoopCAD,

            }
        },
        methods: {
            redirect() {
                if (this.oem.id.toLowerCase() == 'upus') this.$router.push('/download/loopcad/upca')
                else this.$router.push('/download/loopcad/upus')
            },
            goToRevisionHistory() {
                if (this.productLine.name.toLowerCase() == 'loopcad') {
                    this.$router.push(`/support/revisionhistory?productLine=${this.productLine.name.toLowerCase()}&softwareOemId=${this.oem.softwareInternalID}`)
                }
                else {
                    this.$router.push(`/support/revisionhistory?productLine=${this.productLine.name.toLowerCase()}`)
                }
            },
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.oemId = this.$route.query.oem
        }

    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-sm-max) {
        .img-logo {
            max-height: 60px;
        }

        .img-oem-logo {
            max-height: 85px !important;
        }
    }

    .img-oem-logo {
        max-width: 275px;
        max-height: 100%;
        height: unset;
    }
</style>
